import { AuditEntity } from "@app/common";
import { PaymentCycle } from "@app/core";
import { prop, propArray, required } from "@messaia/cdk";
import { BillSource } from "../enums/bill-source";
import { BundleProduct } from "./bundle-product";

export class Bundle extends AuditEntity {
	@prop()
	id: number;

	@prop()
	tariffId: number;

	@required()
	name: string;

	@prop()
	providerId: number;

	@prop()
	providerAltId: number;

	@prop()
	billSource: BillSource;

	@prop()
	optional: boolean;

	@prop()
	enabled: boolean;

	@required()
	paymentCycle: PaymentCycle = PaymentCycle.Monthly;

	@required({ conditionalExpression: (x: Bundle) => x.paymentCycle == PaymentCycle.Monthly })
	minimumTerm: number = 12;

	@required({ conditionalExpression: (x: Bundle) => x.paymentCycle == PaymentCycle.Monthly })
	renewalPeriod: number = 12;

	@required({ conditionalExpression: (x: Bundle) => x.paymentCycle == PaymentCycle.Monthly })
	noticePeriod: number = 12;

	@required({ conditionalExpression: (x: Bundle) => x.paymentCycle == PaymentCycle.Monthly })
	reduced: boolean = false;

	@required({ conditionalExpression: (x: Bundle) => x.reduced })
	reductionTimeLimit: number | null;

	@prop()
	quantityEditable: boolean;

	@required({ conditionalExpression: (x: Bundle) => x.quantityEditable })
	minQuantity: number = 1;

	@required({ conditionalExpression: (x: Bundle) => x.quantityEditable })
	maxQuantity: number = 99;

	@required({ conditionalExpression: (x: Bundle) => x.quantityEditable })
	defaultQuantity: number = 1;

	@required({ conditionalExpression: (x: Bundle) => x.quantityEditable })
	quantityStep: number = 1;

	@prop()
	bundleDependencies: number[];

	@prop()
	productDependencies: number[];

	@prop()
	excludes: number[];

	@prop()
	mandatoryDependency: boolean;

	@prop()
	ordering: number = 0;

	@propArray(BundleProduct)
	products: BundleProduct[] = [new BundleProduct()];

	/**
	 * constructor
	 * @param init 
	 */
	public constructor(init?: Partial<Bundle>) {
		super(init);
		Object.assign(this, init);
	}
}